import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const Eyebrow = ({ children, light = false }) => (
  <p className={`flex items-center gap-3 text-xs font-bold uppercase tracking-[0.24em] ${light ? "text-[#F7D048]" : "text-[#C9503F]"}`}>
    <span className={`h-px w-8 ${light ? "bg-[#F7D048]" : "bg-[#F26D5A]"}`} />
    {children}
  </p>
);
